export function initVersionAutoReload(intervalMs = 60000) {
  const meta = document.querySelector('meta[name="app-build-id"]');
  const currentBuildId = meta?.getAttribute('content') || '';

  if (!currentBuildId) {
    return () => {};
  }

  let cancelled = false;

  const checkForUpdate = async () => {
    try {
      const response = await fetch('/index.html', { cache: 'no-store' });
      if (!response.ok) {
        return;
      }

      const html = await response.text();
      const match = html.match(/<meta\s+name=["']app-build-id["']\s+content=["']([^"']+)["']\s*\/?>/i);
      const latestBuildId = match?.[1] ?? '';

      if (!cancelled && latestBuildId && latestBuildId !== currentBuildId) {
        const url = new URL(window.location.href);
        url.searchParams.set('build', latestBuildId);
        window.location.href = url.toString();
      }
    } catch {
      // ignore — will retry on next interval
    }
  };
  checkForUpdate();
  const intervalId = window.setInterval(checkForUpdate, intervalMs);

  return () => {
    cancelled = true;
    window.clearInterval(intervalId);
  };
}
